import { PropertyGrid, TextInput } from '@leverege/ui-elements';
import React, { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ColorRangeEditor(props) {
  const {
    value,
    model,
    onChange: pOnChange,
    eventData
  } = props;
  const colors = model.getAll(value);
  const onChange = useCallback(evt => {
    const nValue = model.set(value, evt.data, evt.value);
    pOnChange({
      data: eventData,
      value: nValue
    });
  }, [pOnChange, eventData, value, model]);
  return /*#__PURE__*/_jsx(PropertyGrid, {
    children: colors.map((color, index) => {
      let label;
      if (index === 0) {
        label = 'Least Dense';
      } else if (index === colors.length - 1) {
        label = 'Most Dense';
      } else {
        label = null;
      }
      return /*#__PURE__*/_jsx(PropertyGrid.Item, {
        label: label,
        children: /*#__PURE__*/_jsx(TextInput, {
          value: color,
          onChange: onChange,
          eventData: index
        }, color)
      }, color);
    })
  });
}